exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content {\n  max-height: 70vh;\n  overflow: auto\n}\n\n.bottom-row {\n  margin-top: 10px;\n  padding-left: 10px\n}\n\n.last-update{\n  font-size: 14px;\n  font-weight: bold;\n  padding: 15px 0;\n  border-top: 1px dashed #CCC;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal/privacy-policy-modal.component.css
// module id = 840
// module chunks = 0